import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import getBrowserFingerprint from "get-browser-fingerprint";
import Popup from "./Elements/AlertPopup";
import { Base64 } from 'js-base64';

export default function UniqueCodeByUrl() {
  const fingerprint = getBrowserFingerprint();
  const navigate = useNavigate();
  const { code } = useParams();

  const [showPopup, setShowPopup] = useState(false);
  const [agencyName, setAgencyName] = useState("");
  const [agencyData, setAgencyData] = useState(null); // <-- store data temporarily
  const [resforPopUp, setResonse] = useState(null);
  useEffect(() => {
    if (!code) {
      navigate("/");
      return;
    }

    const verifyAgencyByCode = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_ENDPOINT}/varifyagency`,
          { code }
        );

        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          const first = res.data[0];
          const welcome = first.welcomeMessage || "";

          // store API response data temporarily (not in localStorage yet)
          setAgencyData({
            agencyId: first.agencyId,
            agencyEmail: first.agencyEmail,
            code,
          });

          if (welcome.trim() !== "") {
            setAgencyName(welcome);
            setResonse(first);
            setShowPopup(true);
            return;
          }
        }

        // if no popup message, just redirect
        navigate("/");
      } catch (error) {
        
        localStorage.removeItem("page");
        navigate("/");
      }
    };

    verifyAgencyByCode();

    // push event to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "customEvent",
      eventCategory: "Event",
      eventAction: "URL",
      eventLabel: "Agency_Code",
      eventValue: code,
    });
  }, [code, fingerprint, navigate]);

  const closeModal = () => {
    setShowPopup(false);
    navigate("/");
  };

  const handlePopupSubmit = () => {
    if (agencyData) {
      // ✅ Save data to localStorage only after popup confirmation
      localStorage.setItem("aGencyID", agencyData.agencyId);
      localStorage.setItem("agencyEmail", agencyData.agencyEmail);
      localStorage.setItem("aGencyCcod", agencyData.code);
      localStorage.setItem("PID", Base64.encode(fingerprint + "P2"));
    }

    setShowPopup(false);
    navigate("/");
    setTimeout(() => window.location.reload(), 100);
  };

  
    const onNo = () => {
      setShowPopup(false);
      
      navigate("/");
      setTimeout(() => {
      }, 5000);
    }

  return (
    <>
      <Popup
              isOpen={showPopup}
              closeModal={closeModal}
              onYes={handlePopupSubmit}
              aggencyName={agencyName}
              resforPopUp={resforPopUp}
              onNo={onNo}
            />
    </>
  );
}
